// Sportpacks Redesign - (c) 2026 NextPercent, nextpercent.de
// Lizenziert ausschliesslich fuer sport-packs.myshopify.com.
// Einsatz in weiteren Shops nur mit schriftlicher Genehmigung: info@nextpercent.de
if (!window.spProductDetailsReady) {
  window.spProductDetailsReady = true;
  const words = {
    de: ['Zustand', 'Größe laut Etikett', 'Passform', 'Farbe', 'Material', 'Maße', 'Größe'],
    en: ['Condition', 'Label size', 'Fits like', 'Colour', 'Material', 'Measurements', 'Size'],
    fr: ['État', 'Taille sur l’étiquette', 'Taille estimée', 'Couleur', 'Matière', 'Mesures', 'Taille'],
    it: ['Condizioni', 'Taglia in etichetta', 'Vestibilità', 'Colore', 'Materiale', 'Misure', 'Taglia'],
    es: ['Estado', 'Talla de etiqueta', 'Ajuste', 'Color', 'Material', 'Medidas', 'Talla']
  };
  function prepare(root = document) {
    const labels = words[document.documentElement.lang.split('-')[0]] || words.en;
    root.querySelectorAll('[data-sp-product-copy]:not([data-sp-copy-ready])').forEach(copy => {
      copy.dataset.spCopyReady = 'true';
      const facts = document.createElement('dl');
      facts.className = 'sp-product-facts';
      const add = (label, value) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const definition = document.createElement('dd');
        term.textContent = label; definition.textContent = value;
        row.append(term, definition); facts.append(row);
      };
      copy.querySelectorAll('p,li').forEach(node => {
        if (node.querySelector('img,video,iframe,a,table,ul,ol')) return;
        const text = node.textContent.replace(/\s+/g, ' ').trim();
        if (!text || /^\(VTD-[A-Z0-9-]+\)$/.test(text) || /^Notiz:?$/i.test(text)) {
          node.remove(); return;
        }
        if (/^Als PREMIUM markieren wir Artikel die eine ausgezeichnete Qualität\s*aufweisen, sowie extrem selten\s*&\s*besonders sind\.?$/i.test(text)) {
          node.textContent = 'Premium-Auswahl: Artikel von ausgezeichneter Qualität, die wir als besonders selten einstufen.';
          return;
        }
        const match = text.match(/^(Condition|Zustand|Größe|Size|Farbe|Colour|Color|Material|Maße)\s*:\s*(.+)$/i);
        // Only extract single facts. Keep mixed paragraphs and unknown details intact.
        if (!match || node.querySelector('br')) return;
        const key = match[1].toLowerCase();
        const value = match[2].trim();
        if (/^(größe|size)$/.test(key)) {
          const fit = value.split(/\s+but\s+fits\s+like\s+/i);
          add(fit.length > 1 ? labels[1] : labels[6], fit[0]);
          if (fit.length > 1) add(labels[2], fit.slice(1).join(' '));
        } else {
          add(labels[/^(condition|zustand)$/.test(key) ? 0 : /^(farbe|colour|color)$/.test(key) ? 3 : key === 'material' ? 4 : 5], value);
        }
        node.remove();
      });
      if (facts.children.length) copy.prepend(facts);
      // Collapse only adjacent breaks; text between breaks must retain its line break.
      copy.querySelectorAll('br').forEach(br => {
        const next = br.nextSibling;
        if (next?.nodeType === Node.ELEMENT_NODE && next.tagName === 'BR') br.remove();
      });
    });
  }
  prepare();
  document.addEventListener('shopify:section:load', event => prepare(event.target));
  document.addEventListener('click', async event => {
    const link = event.target.closest('[data-sp-open-details]');
    if (!link) return;
    const details = document.getElementById(link.hash.slice(1));
    if (!details) return;
    event.preventDefault();
    const accordion = details.closest('sp-collection-accordion');
    if (accordion?.setOpen) accordion.setOpen(true); else details.open = true;
    details.querySelector('summary').focus({preventScroll: true});
    details.scrollIntoView({block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  });
}
